<template>
  <div class="ask-question">
    <editWin
      :width="500"
      v-model="show"
      title="提示"
      addApi="/saasbaihui/editPatientLabel"
      @addSuccess="addSuccess"
      @cancel="cancel"
      @close="close"
      :formInputList="formInputList"
      :isFixed="true"
      :titleSplicing="false"
      :formatData="formatData"
    >
      <template #before>
        <div class="head-title">
          确定将
          <b>{{ patientInfo.patientName }} {{ patientInfo.cellphoneNo }}</b>
          标记为应筛选患者吗?
        </div>
      </template>
    </editWin>
  </div>
</template>

<script>
export default {
  props: {
    patientInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      show: false,
      activeItem: null,
      formInputList: [],
      storeItem: null,
    };
  },
  methods: {
    open(res, item) {
      this.storeItem = item;
      this.activeItem = res;
      this.restart();
      this.show = true;
    },

    restart() {
      this.formInputList = [
        {
          type: "textarea",
          field: "filterReason",
          title: "原因",
          value: "",
          required: true,
        },
      ];
    },

    formatData(data) {
      Object.assign(data, this.activeItem);
      return data;
    },

    addSuccess() {
      this.show = false;
      this.$emit("addSuccess");
    },

    cancel() {
      let item = this.storeItem.labels.find((i) => i.label == "应筛选患者");
      if (item) {
        let index = this.storeItem.value.indexOf(item.value);
        if (index != -1) {
          this.storeItem.value.splice(index, 1);
        }
      }
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped lang="scss">
.ask-question {
  .head-title {
    margin-bottom: 20px;
  }
}
</style>